import ReactTooltip from 'react-tooltip';
import styled, { css } from 'styled-components';
import theme from 'ui/theme';

import { pxToRem } from 'utils/scss';

export const TootipStyle = styled(ReactTooltip)`
  border-radius: ${pxToRem('4px')};
  box-shadow: 0 ${pxToRem('12px')} ${pxToRem('16px')} -${pxToRem('8px')} rgb(7
        11 21 / 16%);
  background-color: white;
  height: fit-content;
  color: black;
  font-family: ${props => props.theme.fontset.opensans};
  font-size: 0.8rem;
  padding: ${pxToRem('20px')} ${pxToRem('32px')} !important;
  border-radius: ${pxToRem('10px')} !important;
  z-index: 999999;

  ${props =>
    props.errorInResetPasswordLogin &&
    css`
      color: ${theme().colors.semantic.secondary} !important;

      ul {
        list-style-type: circle !important;
      }
    `}
`;
